import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class SamlIntegration extends ApplicationRecord {
  static jsonapiType = "saml_integrations";

  @Attr() customAttributes: Record<string, any>;

  @Attr() domains: Record<string, any>;

  @Attr() idpCertificate: string;

  @Attr() idpEntityId: string;

  @Attr() idpUrl: string;

  @BelongsTo() organisation: Organisation;

  @Attr({ persist: false }) scimToken: string;
}

export default SamlIntegration;
